import React from 'react';

/**
 * Towing Operations Form Component
 */
const TowingOperationsForm = ({ formData, setFormData, onSubmit, onCancel }) => {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="px-6 py-4 border-b">
        <h3 className="text-sm font-medium text-gray-900">Record Towing Operation</h3>
      </div>
      <form onSubmit={onSubmit} className="p-6 space-y-4">
        {/* Date/Time/Type */}
        <div className="grid grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Date</label>
            <input
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Start Time</label>
            <input
              type="time"
              value={formData.startTime}
              onChange={(e) => setFormData({ ...formData, startTime: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">End Time</label>
            <input
              type="time"
              value={formData.endTime}
              onChange={(e) => setFormData({ ...formData, endTime: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Operation Type</label>
            <select
              value={formData.operationType}
              onChange={(e) => setFormData({ ...formData, operationType: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            >
              <option value="harbor">Harbor Tow</option>
              <option value="ocean">Ocean Tow</option>
              <option value="salvage">Salvage</option>
              <option value="escort">Escort</option>
              <option value="barge">Barge Tow</option>
            </select>
          </div>
        </div>
        
        {/* Towed Vessel Details */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">Towed Vessel Details</label>
          <div className="grid grid-cols-4 gap-4">
            <div>
              <input
                type="text"
                value={formData.towedVessel.name}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  towedVessel: { ...formData.towedVessel, name: e.target.value }
                })}
                placeholder="Vessel name"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                required
              />
            </div>
            <div>
              <input
                type="text"
                value={formData.towedVessel.type}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  towedVessel: { ...formData.towedVessel, type: e.target.value }
                })}
                placeholder="Type (e.g., Barge)"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
            <div>
              <input
                type="number"
                value={formData.towedVessel.grt}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  towedVessel: { ...formData.towedVessel, grt: e.target.value }
                })}
                placeholder="GRT"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
            <div>
              <input
                type="number"
                value={formData.towedVessel.length}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  towedVessel: { ...formData.towedVessel, length: e.target.value }
                })}
                placeholder="Length (m)"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
          </div>
        </div>
        
        {/* Towline Configuration */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">Towline Configuration</label>
          <div className="grid grid-cols-4 gap-4">
            <div>
              <select
                value={formData.towlineConfiguration.type}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  towlineConfiguration: { ...formData.towlineConfiguration, type: e.target.value }
                })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              >
                <option value="wire">Wire</option>
                <option value="synthetic">Synthetic</option>
                <option value="chain">Chain</option>
                <option value="combination">Combination</option>
              </select>
            </div>
            <div>
              <input
                type="text"
                value={formData.towlineConfiguration.diameter}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  towlineConfiguration: { ...formData.towlineConfiguration, diameter: e.target.value }
                })}
                placeholder="Diameter (mm)"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
            <div>
              <input
                type="number"
                value={formData.towlineConfiguration.length}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  towlineConfiguration: { ...formData.towlineConfiguration, length: e.target.value }
                })}
                placeholder="Length (m)"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
            <div>
              <input
                type="number"
                value={formData.towlineConfiguration.workingLoad}
                onChange={(e) => setFormData({ 
                  ...formData, 
                  towlineConfiguration: { ...formData.towlineConfiguration, workingLoad: e.target.value }
                })}
                placeholder="SWL (tonnes)"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
          </div>
        </div>
        
        {/* Performance Data */}
        <div className="grid grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Bollard Pull (t)</label>
            <input
              type="number"
              step="0.1"
              value={formData.bollardPull}
              onChange={(e) => setFormData({ ...formData, bollardPull: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Avg Speed (kts)</label>
            <input
              type="number"
              step="0.1"
              value={formData.averageSpeed}
              onChange={(e) => setFormData({ ...formData, averageSpeed: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Max Speed (kts)</label>
            <input
              type="number"
              step="0.1"
              value={formData.maxSpeed}
              onChange={(e) => setFormData({ ...formData, maxSpeed: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Fuel Used (L)</label>
            <input
              type="number"
              value={formData.fuelConsumed}
              onChange={(e) => setFormData({ ...formData, fuelConsumed: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
        </div>
        
        {/* Weather Conditions */}
        <div className="grid grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Wind Speed (kts)</label>
            <input
              type="number"
              value={formData.weather.windSpeed}
              onChange={(e) => setFormData({ 
                ...formData, 
                weather: { ...formData.weather, windSpeed: e.target.value }
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Wind Dir (°)</label>
            <input
              type="number"
              min="0"
              max="360"
              value={formData.weather.windDirection}
              onChange={(e) => setFormData({ 
                ...formData, 
                weather: { ...formData.weather, windDirection: e.target.value }
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Sea State</label>
            <select
              value={formData.weather.seaState}
              onChange={(e) => setFormData({ 
                ...formData, 
                weather: { ...formData.weather, seaState: e.target.value }
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            >
              <option value="">Select...</option>
              <option value="calm">Calm (0-1)</option>
              <option value="slight">Slight (2-3)</option>
              <option value="moderate">Moderate (4-5)</option>
              <option value="rough">Rough (6-7)</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Visibility</label>
            <select
              value={formData.weather.visibility}
              onChange={(e) => setFormData({ 
                ...formData, 
                weather: { ...formData.weather, visibility: e.target.value }
              })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
            >
              <option value="">Select...</option>
              <option value="good">Good (&gt;5nm)</option>
              <option value="moderate">Moderate (2-5nm)</option>
              <option value="poor">Poor (&lt;2nm)</option>
              <option value="fog">Fog</option>
            </select>
          </div>
        </div>
        
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex-1 px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700"
          >
            Save Tow Record
          </button>
        </div>
      </form>
    </div>
  );
};

export default TowingOperationsForm;